import React from 'react';
import { GeometryCanvas } from '../../core/math/GeometryCanvas';
import type { GeometryCanvasPayload } from '../../core/types/payloads/geometry_canvas.types';

export function GeometryCanvasReadView({ payload }: { payload: GeometryCanvasPayload }) {
  return (
    <div className="geometry-canvas-view">
      <h3 className="eval-block__title">{payload.title}</h3>
      {payload.sectionTitle && payload.sectionTitle !== payload.title && (
        <p className="text-sm text-[var(--sala-ink-muted)]">{payload.sectionTitle}</p>
      )}
      {payload.bodyText && <p className="eval-block__body">{payload.bodyText}</p>}
      {payload.prompt && <p className="geometry-canvas-view__prompt">{payload.prompt}</p>}
      <div className="geometry-canvas-view__stage">
        <GeometryCanvas geometry={payload.geometry} caption={payload.title} />
      </div>
      {payload.formulaHint && (
        <p className="geometry-canvas-view__formula">{payload.formulaHint}</p>
      )}
    </div>
  );
}
